export const MODAL_STEP_STATUS = {
    SUCCESS: 'success',
    FAILED: 'failed',
    OTP: 'otp',
    START: 'start',
} as const;

export const MODAL_TYPES = {
    REFUND: 'refund',
    OTP: 'otp',
    VOID: 'void',
    CAPTURE: 'capture',
} as const;

export const CUSTOMER_TAPS = {
    CUSTOMER: 'customer',
    BILLING: 'billing',
    SHIPPING: 'shipping'
} as const;

export const VISIBLE_ACTION_BTNS = 2;
export const NOTIFICATION_TIMEOUT = 4;
export const MAX_MODAL_WIDTH = "35rem";
export const MAX_NOTIFICATION_WIDTH = "30rem";

export const MADA_NAME = 'MADA';
export const MADA_SCHEME = 'Mada';